import { ReactNode } from 'react';
import RestrictionModal from '@/components/RestrictionModal';
import useLearningRestrictions from '@/hooks/useLearningRestrictions';

type LearningRestrictionKey = 'quizEnabled' | 'mockExamEnabled' | 'viewTextEnabled' | 'examEnabled';

type LearningRestrictionGuardProps = {
  restrictionKey: LearningRestrictionKey;
  children: ReactNode;
};

export default function LearningRestrictionGuard({
  restrictionKey,
  children,
}: LearningRestrictionGuardProps) {
  const { settings, loading } = useLearningRestrictions();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">読み込み中...</div>;
  }

  if (!settings[restrictionKey]) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
        <RestrictionModal open={true} message={settings.message} onAction={() => undefined} />
      </div>
    );
  }

  return <>{children}</>;
}
